import React, { useEffect, useState } from "react";
import Header from "./Home/Header";
import Footer from "./Home/Footer";


export default function ComingSoon() {
    const [time, setTime] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        const target = new Date("2026-01-01").getTime();

        const interval = setInterval(() => {
            const now = new Date().getTime();
            const diff = target - now;

            setTime({
                days: Math.floor(diff / (1000 * 60 * 60 * 24)),
                hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((diff / (1000 * 60)) % 60),
                seconds: Math.floor((diff / 1000) % 60),
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <div className="coming-container">
                <Header />

                {/* Glow Background */}
                <div className="glow glow1"></div>
                <div className="glow glow2"></div>

                <div className="content">
                    <h1>🚀 Coming Soon</h1>

                    <p>
                        We are working on something amazing. Stay tuned for the launch.
                    </p>

                    {/* Countdown */}


                    {/* Email */}

                </div>
            </div>
            {/* <Footer /> */}
        </>
    );
}